import React from "react";
import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import theme from "./theme";
import "./styles/fonts.css";
import Layout from "./components/Layout";
import LandingPage from "./pages/LandingPage";
import TournamentCreationPage from "./pages/TournamentCreationPage";
import PlayersPage from "./pages/PlayersPage";
import LiveScoringPage from "./pages/LiveScoringPage";
import GolfPoolPage from "./pages/GolfPoolPage";
import NewLandingPage from "./pages/NewLandingPage";
import ArchiveLandingPage from "./pages/ArchiveLandingPage";
import PastWinner from "./pages/PastWinner";
import TheCause from "./pages/TheCause";
import LoginPage from "./pages/LoginPage";
import AuditPage from "./pages/AuditPage";
import { AuthProvider } from "./contexts/AuthContext";
import { TournamentProvider } from "./contexts/TournamentContext";

function App() {
  return (
    <ChakraProvider theme={theme}>
      <AuthProvider>
        <Router>
          <TournamentProvider>
            <Layout>
              <Routes>
                <Route path="/" element={<NewLandingPage />} />
                <Route path="/leaderboard" element={<LandingPage />} />
                <Route path="/live-scoring" element={<LiveScoringPage />} />
                <Route path="/players" element={<PlayersPage />} />
                <Route path="/tournament" element={<TournamentCreationPage />} />
                <Route path="/golf-pool" element={<GolfPoolPage />} />
                <Route path="/past-winners" element={<PastWinner />} />
                <Route path="/the-cause" element={<TheCause />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/audit" element={<AuditPage />} />

                <Route path="/2025" element={<ArchiveLandingPage />} />
                <Route path="/2025/leaderboard" element={<LandingPage />} />
                <Route path="/2025/live-scoring" element={<LiveScoringPage />} />
                <Route path="/2025/players" element={<PlayersPage />} />
                <Route path="/2025/golf-pool" element={<GolfPoolPage />} />
              </Routes>
            </Layout>
          </TournamentProvider>
        </Router>
      </AuthProvider>
    </ChakraProvider>
  );
}

export default App;
